export enum SESSION_KEY {
  ALL = 'All',
  ACCOUNT_CHECK = 'ac',
  DIAGNOSTIC_CHECK = 'dc',
  DIAGNOSTIC_FLOW = 'df',
  BOOKING_ENGINEER = 'be',
  IDENTIFICATION = 'id',
  LOCATION = 'loc',
  SERVICE_STATUS = 'ss',
  OTP_LOGIN = 'otp',
  CONTACT_DETAILS = 'cd',
  BB_RELIABILITY = 'ivr_bb',
  SS_POD_ORDER = 'ss_pod_order',
  CUSTOMER_INFO = 'ci',
  FEATURE_FLAGS = 'ff',
}

export enum SESSION_EXPIRY {
  NEVER = 0,
  ONE_SECOND = 1,
  FIFTEEN_SECONDS = 15,
  THIRTY_SECONDS = 30,
  ONE_MINUTE = 60,
  FIVE_MINUTES = 300,
  FIFTEEN_MINUTES = 1500,
  THIRTY_MINUTES = 3000,
  ONE_HOUR = 6000,
}
